import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import "./styles.scss";

const SearchInput = ({ value, onChange, onClear, placeholder = "Search..." }) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <div className="search-input-wrapper">
      <FaSearch className="search-input-icon" />
      <input
        type="text"
        className="search-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {value && (
        <button className="search-input-clear" onClick={handleClear} type="button">
          <FaTimes />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
